import React from 'react'
import { MoneyGroupedStyled } from './MoneyGrouped.styles'
import { PriceChange } from './utils'

export interface MoneyGroupedProps {
  price: number
  priceChange?: PriceChange
}

export const MoneyGrouped = ({ price, priceChange }: MoneyGroupedProps) => {
  return <MoneyGroupedStyled price={price} priceChange={priceChange} amount={price} />
}
